import List from '../../components/List/List';
import { categories } from '../../utils/cardInfo';

const PatentsPage = () => {
  return (
    <List
      category={'patents'}
      heading={'Patents'}
      cardHeader={categories.patents.cardHeader}
      icons={categories.patents.icons}
      dotColor={categories.patents.dotColor}
    />
  );
};
export default PatentsPage;
